import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `ControlSangre/eliminarControlSangreSeleccion`, method: 'POST', body: {list}, token: token})
}